import React, {  } from 'react';
import SearchIcon from '../../assets/images/drop_down_filter.svg';
import './ListFilterComponent.scss';
import { Image } from 'react-bootstrap';


const BaseSearchBar = ({
  searchPlaceholder = "Search by name",
  value,
  setValue,
  type="text",
  ...extraInputProps
}) => {
  return (
    <div className='list-filter-list-search-section'>
      <Image src={SearchIcon} className="list-filter-search-icon" />
      <input
        value={value}
        onChange={({ target }) => setValue(target.value)}
        type={type}
        className="list-filter-search-field"
        placeholder={searchPlaceholder || ""}
        {...extraInputProps}
      />
    </div>
  )
}

export default BaseSearchBar